module.exports = __webpack_public_path__ + "img/xclcy.bdc2831d.png";